import { AdminApi } from 'stylemix-vue-admin'

export default class DriversApi extends AdminApi {
  constructor(parameters) {
    super('drivers', parameters)
  }
}
